import { render, staticRenderFns } from "./TodayListDetail.vue?vue&type=template&id=22ccdab0&scoped=true&"
import script from "./TodayListDetail.vue?vue&type=script&lang=js&"
export * from "./TodayListDetail.vue?vue&type=script&lang=js&"
import style0 from "./TodayListDetail.vue?vue&type=style&index=0&id=22ccdab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ccdab0",
  null
  
)

component.options.__file = "TodayListDetail.vue"
export default component.exports